<ion-split-pane contentId="main-content">
  <ion-menu contentId="main-content" type="overlay" side="end">
    <ion-content>
      <div class="flex flex-column space-between height-100">
        <div class="margin-top-40">
          @if (user(); as user) {
            <div class="padding-16">
              <work-ui-infoblock
                [avatarImgSrc]="user.userImage ? (user.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
                [label]="user.jobtitle || ''"
                [title]="user.firstName! + ' ' + user.lastName! || ''"
                [subtitle]="user.mobileprivate"
                [withAvatar]="true"
                [textCenteredVertically]="true"
                avatarStatus="none" />
            </div>
          }
          @for (route of mitarbeitendeRoutes; track route; let i = $index) {
            <ion-menu-toggle auto-hide="false">
              <work-ui-button [text]="route.title"
                              [iconName]="route.icon"
                              variant="tertiary"
                              routerDirection="root"
                              routerLinkActive="selected"
                              [routerLink]="[route.url]" />
            </ion-menu-toggle>
          }
          @if (showAkquise()) {
            <ion-menu-toggle auto-hide="false">
              <work-ui-button text="AKQUISEOBJEKTE"
                              iconName="add_location_alt"
                              variant="tertiary"
                              routerDirection="root"
                              routerLinkActive="selected"
                              [routerLink]="['/mitarbeitende/akquise']" />
            </ion-menu-toggle>
          }
          @if (hasMontageplanRead()) {
            <ion-menu-toggle auto-hide="false">
              <work-ui-button text="MONTAGEPLAN"
                              iconName="calendar_month"
                              variant="tertiary"
                              routerDirection="root"
                              routerLinkActive="selected"
                              [routerLink]="['/mitarbeitende/montageplan']" />
            </ion-menu-toggle>
          }
        </div>
        <div class="padding-16">
          <work-ui-select label="SPRACHE"
                          [options]="languageOptions"
                          [value]="selectedLanguageOption()"
                          [hideHint]="true"
                          (valueChanged)="changeLanguage($event)" />
          <work-ui-button text="ABMELDEN" iconName="logout" (buttonClick)="logout()" />
        </div>
      </div>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>
